<template>
  <div v-if="tolRef" class="tol-ref">
    <span class="tol-ref__key">Ref</span>
    <span class="tol-ref__value">{{ tolRef }}</span>
    <span class="tol-ref__action" role="button" @click="$emit('view')">View ↗</span>
  </div>
</template>

<script>
/**
 * Right-panel tolerance reference strip.
 *
 * Shows the applied rule source doc for the active check (or falls back to
 * verification-level spec) with a "View ↗" affordance.
 *
 * Wireframe reference: AVA Verification Wireframe.html lines 500-504, 860-864.
 */
export default {
  name: 'ToleranceRefStrip',
  props: {
    tolRef: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/verification-tokens';

.tol-ref {
  padding: 12px 16px;
  border-top: 1px solid $vf-line-soft;
  font-size: 11px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #fafafa;

  &__key {
    color: $vf-ink-3;
    font-family: $vf-font-mono;
    font-size: 10px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    white-space: nowrap;
  }

  &__value {
    font-family: $vf-font-mono;
    font-size: 11px;
    color: $vf-ink;
    font-weight: 500;
    flex: 1;
  }

  &__action {
    color: $vf-primary;
    font-size: 11px;
    font-weight: 500;
    cursor: pointer;
    white-space: nowrap;
  }
}
</style>
